// import Vue from 'vue'
// /**
//  * 一个功能的引导可能涉及多个页面（以估算模型管理的引导为例，涉及估算模型管理、添加模型的弹框 两个页面，原本是四个步骤，从估算模型管理页面点击下一步到弹框页面，引导框比弹框先渲染，导致弹框无法高亮且引导框的位置也不对，只能采取重启引导步骤的方法，所以把四个步骤按页面拆分），思路就是到另一个页面就重启流程
//  * @param {*} module 表示一个页面
//  * @param {*} introTask 表示一套完整的引导步骤
//  */
// export function guide (module,introTask,introStatus) {
//   // console.log('Vue',module,introTask,introStatus);
//   let steps = []
//   let intro = Vue.prototype.$intro()
//   if(module == '实物量'){
//     steps = [
//       {
//         element: '#swlStep_1',
//         title:'(1/6)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>实物量</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击[实物量]按钮查看各资源相关数据信息~</div>`,
//       },
//       {
//         element: '#areaLocationStep_2',
//         title:'(2/6)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>区域选择</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>选择需要查询的区域~</div>`,
//       },
//       {
//         element: '#swlStep_3',
//         title:'(3/6)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>年份选择</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>选择年份查看不同年度数据~</div>`,
//         position:'top'
//       },
//       {
//         element: '#swlStep_4',
//         title:'(4/6)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>查看更多</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击更多按钮或者[土地资源]标题，查看各资源模块下详细的资源数据~</div>`,
//       },
//       {
//         element: '#swlStep_5',
//         title:'(5/6)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>地块类型选择</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>选择土地资源模块下[农用地]类型会在地图上展示地块~</div>`,
//       },
//     ]
//   }else if(module == '趋势分析'){
//     steps = [
//       {
//         element: '#qsfxStep_1',
//         title:'(1/5)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>趋势分析</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击[趋势分析]按钮查看各资源在不同维度下的趋势变动情况~</div>`,
//       },
//       {
//         element: '#areaLocationStep_2',
//         title:'(2/5)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>区域选择</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>选择需要查询的区域~</div>`,
//       },
//       {
//         element: '#qsfxStep_3',
//         title:'(3/5)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>时间段选择</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>选择对应年份区间段，查看不同年度数据~</div>`,
//         position:'top'
//       },
//       {
//         element: '#qsfxStep_4',
//         title:'(4/5)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>点击图表</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击[土地资源]图表，查看更多相关数据~</div>`,
//         position:'right'
//       },
//       {
//         element: '#qsfxStep_5',
//         title:'(5/5)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>维度选择</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>选择不同维度，查看各资源实物量和价值量汇总信息~</div>`,
//         position:'top'
//       },
//     ]
//   }else if(module == '土地资源'){
//     steps = [
//       {
//         element: '#tdzyStep_1',
//         title:'(1/1)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>饼图二级分类展示</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击饼图，可出现弹窗，展示二级分类数据~</div>`,
//         position:'right'
//       },
//     ]
//   }else if(module == '一张图-分析'){
//     steps = [
//       {
//         element: '#analysisStep_1',
//         title:'(1/2)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>叠加分析</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击[分析]，选择分析类型~</div>`,
//       },
//       {
//         element: '#analysisStep_2',
//         title:'(2/2)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>信息录入</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>可通过上传/手绘/选择图斑的方式确定分析范围；选择图层 > 字段 > 范围 > 算法；点击操作列的分析按钮，计算出相应的数据信息~</div>`,
//       },
//     ]
//   }else if(module == '一张图-识别'){
//     steps = [
//       {
//         element: '#identifyStep_1',
//         title:'(1/2)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>识别</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>识别当前层~</div>`,
//       },
//       {
//         element: '#layerStep',
//         title:'(2/2)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>图层管理</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>勾选并选中单个图层，点击要识别的地块，展示相关信息~</div>`,
//         position:'left'
//       },
//     ]
//   }else if(module == '一张图-图上测量'){
//     steps = [
//       {
//         element: '#measureStep_1',
//         title:'(1/1)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>剖面</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击[剖面]按钮，在地图上绘制线段，绘制完成时出现弹窗，显示高程和行程信息~</div>`,
//         position:'left'
//       },
//     ]
//   }else if(module == '一张图-价值估算'){
//     steps = [
//       {
//         element: '#jzgsStep_1',
//         title:'(1/4)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>估算范围</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>可通过上传/手绘/选择图斑的方式确定估算范围~</div>`,
//         position:'left'
//       },
//       {
//         element: '#jzgsStep_2',
//         title:'(2/4)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>估算</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>确定估算范围，列表显示信息~</div>`,
//         position:'left'
//       },
//       {
//         element: '#jzgsStep_3',
//         title:'(3/4)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>信息录入</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>选择年度 > 选择核算模型 > 命名任务名称~</div>`,
//         position:'left'
//       },
//       {
//         element: '#jzgsStep_4',
//         title:'(4/4)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>开始核算</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击[开始核算]按钮即可，核算完成展示相关信息~</div>`,
//       },
//     ]
//   }else if(module == '一张图-查询'){
//     steps = [
//       {
//         element: '#layerStep',
//         title:'(1/2)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>图层管理</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>勾选并选中单个图层~</div>`,
//       },
//       {
//         element: '#searchStep_2',
//         title:'(2/2)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>查询分析</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>选择字段 > 输入需要查询的属性 > 点击查询，列表将显示查询结果~</div>`,
//       },
//     ]
//   }else if(module == '估算模型管理'){
//     // 估算模型管理页面  添加按钮的引导
//     steps = [
//       {
//         element: '#gsStep_1',
//         title:'(1/4)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>添加按钮</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击[添加]按钮进入新的弹窗页面~</div>`,
//       },
//     ]
//   }else if(module == '估算模型管理-添加模型'){
//     // 估算模型管理-添加的弹框页面  功能引导
//     steps = [
//       {
//         element: '#gsStep_2',
//         title:'(2/4)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>添加估算模型</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>输入/选择相关信息，再点击[添加]按钮~</div>`,
//       },
//       {
//         element: '#gsStep_3',
//         title:'(3/4)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>新增计算模型</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击列表'＋'，新增计算模型~</div>`,
//       },
//       {
//         element: document.querySelector('.ant-modal-footer'),
//         title:'(4/4)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>添加估算模型完成</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击[确认]即添加估算模型完成~</div>`,
//         position:'top'
//       },
//     ]
//   }else if(module == '价值量估算-未完成'){
//     // 估算模型管理-添加的弹框页面  功能引导
//     steps = [
//       {
//         element: '#jzlgsStep_1',
//         title:'(1/3)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>添加核算</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击[添加核算]按钮进入新的弹窗页面~</div>`,
//       },
//     ]
//   }else if(module == '价值量估算-添加核算任务'){
//     // 估算模型管理-添加的弹框页面  功能引导
//     steps = [
//       {
//         element: document.querySelector('.ant-modal'),
//         title:'(2/3)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>添加核算任务</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>输入/选择相关信息，再点击[核算]按钮~</div>`,
//         position:'bottom'
//       },
//     ]
//   }else if(module == '价值量估算-已完成'){
//     // 估算模型管理-添加的弹框页面  功能引导
//     steps = [
//       {
//         element: '#jzlgsStep_3',
//         title:'(3/3)',
//         intro: `<div style='font-size:18px; margin:0 0 4px 0;'>对比分析</div>
//                 <div style='font-size:14px; color:rgba(255,255,255,0.5);'>点击[添加核算]按钮进入新的弹窗页面~</div>`,
//       },
//     ]
//   }

//   let doneLabel = ''
//   if(module == '估算模型管理' || module == '价值量估算-未完成' || module == '价值量估算-添加核算任务'){
//     doneLabel = '下一步'
//   }else{
//     doneLabel = '知道了'
//   }

//   intro.setOptions({
//     exitOnOverlayClick: false, //空白处点击不退出
//     disableInteraction: true, // 禁止点击突出显示的内容
//     showBullets: false, // 是否显示面板指示点
//     prevLabel: "上一步", //上一步按钮
//     nextLabel: '下一步',  //下一步按钮
//     skipLabel: "跳过引导",  //跳过按钮
//     doneLabel: doneLabel,  //结束按钮
//     steps: steps,
//   })
//   .oncomplete(function () {
//     // console.log('oncomplete 点击知道了');
//     if(module !== '估算模型管理' && module !== '价值量估算-未完成' && module !== '价值量估算-添加核算任务'){
//       Vue.ls.set(introStatus,'false')
//     }
//   })
//   .onexit(function () {
//     // 退出时触发
//     // console.log('onexit 点击跳过或知道了');
//     if(module == '估算模型管理' && Vue.ls.get(introStatus) !== 'false'){
//       Vue.prototype.$bus.$emit('addModel')
//     }
//     if(module == '价值量估算-未完成' && Vue.ls.get(introStatus) !== 'false'){
//       Vue.prototype.$bus.$emit('addAccount')
//     }
//     if(module == '价值量估算-添加核算任务' && Vue.ls.get(introStatus) !== 'false'){
//       Vue.prototype.$bus.$emit('closeAccountDialog')
//     }
//     if(module == '一张图-分析'){
//       Vue.prototype.$bus.$emit('closeDjfxDialog')
//     }
//   })
//   .onskip(index => {
//     // console.log('onskip 点击跳过',index);
//     Vue.ls.set(introStatus,'false')
//   })
//   .onbeforechange((element,index) => {
//     if(module == '一张图-分析' && index == 0){
//       Vue.prototype.$bus.$emit('openOverlayAnalysisDialog')
//     }
//   })
//   .onchange(element => {})
//   .onafterchange(element => {})
//   .start()
// }